let storeDomain = "designer-doorware-au.myshopify.com";
let apiVersion = "2025-01";
let accessToken = "fe897ac638c3b4bbece4814d25e20187";

let generatedShareLink = "";

function getGlobalPlaceholderImage() {
  return (
    document.querySelector('input[name="default-image-src"]')?.value ||
    document.getElementById("product_card_placeholder")?.value ||
    ""
  );
}

function isImageRenderable(url) {
  if (!url) return Promise.resolve(false);
  return new Promise((resolve) => {
    const img = new Image();
    let settled = false;
    const finish = (result) => {
      if (settled) return;
      settled = true;
      clearTimeout(timeoutId);
      resolve(result);
    };
    img.onload = () => finish(true);
    img.onerror = () => finish(false);
    const timeoutId = setTimeout(() => finish(false), 3000);
    img.src = url;
  });
}

function resolveActualHandle(productData) {
  if (!productData) return "";
  let handle = productData.mainProductHandle || productData.productHandle || "";
  if (handle.includes("-")) {
    const parts = handle.split("-");
    const isSkuDerived = parts.some(p => /^r\d+$/i.test(p));
    if (isSkuDerived) {
      const prefix = parts[0].toLowerCase();
      if (window.allCloudflareProducts) {
        const found = window.allCloudflareProducts.find(p => {
          const pCode = (p.product_code || "").toLowerCase().trim();
          return pCode === prefix && p.handle && !p.handle.split("-").some(seg => /^r\d+$/i.test(seg));
        });
        if (found && found.handle) {
          return found.handle;
        }
        const found2 = window.allCloudflareProducts.find(p => (p.product_code || "").toLowerCase().trim() === prefix);
        if (found2 && found2.handle) {
          return found2.handle;
        }
      }
    }
  }
  return handle;
}

// Bootstrap modal instance (will be initialized after DOM is ready)
let emailModal;

// Run once DOM is fully loaded
document.addEventListener("DOMContentLoaded", () => {
  if (document.getElementById('emailModal')) {
    const modalElement = document.getElementById('emailModal');
    emailModal = new bootstrap.Modal(modalElement);
  }
});
(function () {
  function onSwymLoadCallback(_swat) {
    const collectionLoader = document.getElementById('swym-wishlist-loader-collection');
    const wishlistWrapper = document.querySelector('.wishlist-content-wrapper');
    const wishlistItemsContainer = document.querySelector('.wishlist-items');
    const cartItemsSection = document.querySelector('.cart-items');

    // UI State: Show loader, hide wishlist content
    // if (collectionLoader) collectionLoader.classList.remove('swymcs-hide-container');
    if (wishlistWrapper) {
      wishlistWrapper.style.display = 'none';
      wishlistWrapper.classList.add('d-none');
    }
    document.querySelector('.swym_collection_container').style.opacity = '1';

    const onSuccess = function (lists) {
      console.log('Fetched Lists:', lists);
      wishlistItemsContainer.innerHTML = ''; // Clear old entries

      if (lists.length > 0) {
        lists.forEach((list) => {
          const listRow = document.createElement('tr');
          listRow.classList.add('cart-item', 'wishlist_item');
          listRow.innerHTML = `
            <td class="cart-item__media">
              <div class="cart-item__collection-title my-wishlist-title cart_sm_title" style="cursor: pointer;" data-lid="${list.lid}">
                <span class="d-md-none d-inline-block cart_sm_head">Name :</span> ${list.lname}
              </div>
            </td>
            <td class="cart-item__quantity cart_sm_title">
              <span class="d-md-none d-inline-block cart_sm_head">Product Counts :</span>
              <input class="quantity__input" type="number" value="${list.cnt}" readonly aria-label="Quantity" />
            </td>
            <td class="cart_remove_specic">
              <div class="remove-spec-btn d-flex justify-content-end" data-lid="${list.lid}">
                <img src="https://cdn.shopify.com/s/files/1/0881/1662/5712/files/delete_bin.png?v=1735982593" alt="Delete" class="icon-remove" />
              </div>
            </td>
            <td class="cart_prod_btn">
              <button class="view-products-btn" data-lid="${list.lid}">View Products</button>
            </td>
          `;

          wishlistItemsContainer.appendChild(listRow);

          // Event Listeners
          const viewButton = listRow.querySelector('.view-products-btn');
          const titleLink = listRow.querySelector('.my-wishlist-title');
          const removeButton = listRow.querySelector('.remove-spec-btn');

          [viewButton, titleLink].forEach((el) =>
            el?.addEventListener('click', () => {
              sessionStorage.setItem('selectedListId', list.lid);
              window.open(`${window.Shopify.routes.root}pages/specbook-products`, '_self');
            })
          );

          removeButton?.addEventListener('click', () => {
            if (confirm('Are you sure you want to remove this wishlist?')) {
              const lid = removeButton.getAttribute('data-lid');
              if (lid) {
                delete_wishlist(lid); // Assumes function is globally available
              }
            }
          });
        });
      } else {
        // No wishlist found
        const noWishlistRow = document.createElement('div');
        noWishlistRow.classList.add('cart-item', 'wishlist_item');
        noWishlistRow.innerHTML = '<p>No wishlist found.</p>';
        wishlistWrapper?.appendChild(noWishlistRow);
        cartItemsSection?.classList.add('d-none');
      }

      // UI State: Hide loader, show wishlist
      if (collectionLoader) collectionLoader.classList.add('swymcs-hide-container');
      if (wishlistWrapper) {
        wishlistWrapper.classList.remove('d-none');
        wishlistWrapper.style.display = 'block';
      }
    };

    const onError = function (error) {
      console.error('Error while fetching wishlists:', error);
    };

    // Trigger Swym list fetch
    _swat.fetchLists({
      callbackFn: onSuccess,
      errorFn: onError,
    });
  }

  // Only run if on correct template
  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }
  if (document.body.classList.contains('template-page-swym-collections')) {
    window.SwymCallbacks.push(onSwymLoadCallback);
  }
})();

function delete_wishlist(lid) {
  let onSuccessDelete = function (deletedListObj) {
    location.reload();
  }

  let onErrorDelete = function (error) {
    console.log(`Error while deleting the List, ${lid}`, error);
  }

  _swat.deleteList(lid, onSuccessDelete, onErrorDelete);
}
function view_wishlist_products(lid, listDiv) {
  (function () {
    function onSwymLoadCallback(_swat) {
      let listConfig = {
        "lid": lid, // lid
      };
      let onSuccess = function (list) {

        const productContainer = listDiv.querySelector('.wishlist-products');
        productContainer.innerHTML = ''; // Clear previous products

        list.items.forEach(function (item) {
          const productDiv = document.createElement('div');
          productDiv.classList.add('wishlist-product');
          productDiv.innerHTML = `
            <p><strong>Product Name:</strong> ${item.dt}</p>
            <p><strong>Product Id:</strong> <a href="${item.du}" target="_blank">${item.empi}</a></p>
            <p><strong>Variant:</strong> ${item.epi}</p>
            <p><strong>Price:</strong> ${item.pr}</p>
          `;
          productContainer.appendChild(productDiv);
        });
      };

      let onError = function (error) {
        console.log("Error while fetching List Products", error);
      };

      _swat.fetchListDetails(listConfig, onSuccess, onError);
    }

    if (!window.SwymCallbacks) {
      window.SwymCallbacks = [];
    }
    window.SwymCallbacks.push(onSwymLoadCallback);
  })();
}

function create_new_wishlist(cname) {
  let listConfig = {
    "lname": cname, // unique list name.
  };

  let onSuccess = function (newList) {
    console.log("Successfully created a new List", newList);
  };

  let onError = function (error) {
    console.log("Error while creating a List", error);
  };

  _swat.createList(listConfig, onSuccess, onError);
}

function view_all_wishlists(epi, empi, du) {
  (function () {
    function onSwymLoadCallback(_swat) {
      let onSuccess = function (lists) {
        const collectionDiv = document.querySelector('.collection-lists');
        collectionDiv.innerHTML = ''; // Clear any existing content

        // Create a list of available collections
        lists.forEach(function (list) {
          const listDiv = document.createElement('div');
          listDiv.classList.add('collection-item');
          listDiv.innerHTML = `
                        <p><strong>List Name:</strong> ${list.lname}</p>
                        <button class="select-collection-btn" data-lid="${list.lid}">Select</button>
                    `;
          collectionDiv.appendChild(listDiv);

          // Add event listener for selecting a collection
          listDiv.querySelector('.select-collection-btn').addEventListener('click', function () {
            // Add the product to the selected collection
            add_to_wishlist(list.lid, epi, empi, du);
          });
        });
      };

      let onError = function (error) {
        console.log("Error while fetching all Lists", error);
      };

      _swat.fetchLists({
        callbackFn: onSuccess,
        errorFn: onError
      });
    }

    if (!window.SwymCallbacks) {
      window.SwymCallbacks = [];
    }
    window.SwymCallbacks.push(onSwymLoadCallback);
  })();
}

function add_to_wishlist(lid, epi, empi, du) {
  var product = {
    epi: epi, // Unique variant ID of the product
    empi: empi, // Master Product Id of the product
    du: du // Product URL
  };

  let onSuccess = function (addedListItem) {
    console.log(`Successfully added the Product to List with lid ${lid}`, addedListItem);
    alert('Product added to the selected collection!');
  };

  let onError = function (error) {
    console.log("Error while adding the Product to the List", error);
    alert('An error occurred while adding the product.');
  };

  _swat.addToList(lid, product, onSuccess, onError);
}



(function () {
  async function onSwymLoadCallbackProducts(_swat) {
    const errorWrapper = document.getElementById('cart-errors');
    document.getElementById('swym-wishlist-loader').classList.remove('swymcs-hide-container');
    document.querySelector('.main_cart_items_wrapper').classList.add('d-none');

    // Prefer the share-link params (hkey/lid) so a link shared by another shopper
    // opens THAT list, instead of falling back to whatever is in this browser's
    // sessionStorage (which is empty/stale for a fresh visitor on a share link).
    const urlParams = new URLSearchParams(window.location.search);
    const sharedHkey = urlParams.get('hkey');
    const sharedLid = urlParams.get('lid');
    const listId = sharedHkey || sharedLid || sessionStorage.getItem('selectedListId');
    const isSharedLink = !!(sharedHkey || sharedLid);
    // alert(listId);
    // return;
    let totalPrice = 0;
    let productsToAddToCart = { items: [] };
    let lastListDetails = null; // hoisted so addToCartBtn click handler can access the latest fetched list
    let listConfig = isSharedLink
      ? { "lid": listId, "hkey": sharedHkey || undefined }
      : { "lid": listId };
    let productCount = 0;
    let onSuccess = async function (listDetails) {
      lastListDetails = listDetails; // keep outer reference up-to-date on every fetch/refresh
      totalPrice = 0;
      document.getElementById("download-all-cart-specs").addEventListener("click", function (event) {
        event.preventDefault();
        getAllSpecData(listDetails);
      });
      const currencySymbol = document.getElementById('swym_currency_symbol').value;
      const wishlistTitle = document.querySelector('.wishlist-heading-text');
      wishlistTitle.innerHTML = listDetails.list.lname;
      const activeBreadcrumb = document.querySelector('.breadcrumb-item.active[aria-current="page"]');
      if (activeBreadcrumb) {
        activeBreadcrumb.textContent = listDetails.list.lname;
      }
      const productContainer = document.querySelector('.wishlist-products');
      productContainer.innerHTML = ''; // Clear any previous content
      if (listDetails && listDetails.items && listDetails.items.length > 0) {
        for (let product of listDetails.items) {
          try {
            let variantData = null;
            if (product.epi) {
              variantData = await fetchVariantById(product.epi);
            }
            //console.log(product);
            const mainProductId = product.empi;
            let getProductData = null;
            if (mainProductId) {
              getProductData = await fetchProductByProductId(mainProductId);
            }
            if (!getProductData && product.du) {
              const handleFromUrl = product.du.split('/').pop().split('?')[0];
              getProductData = await fetchProductByHandle(handleFromUrl);
            }
            if (getProductData) {
              product.productData = getProductData;
              let isProductAvailable = true;
              console.log(getProductData.mainProductHandle, getProductData.variantSKU);
              const productHandle = getProductData.productHandle;
              let productUrl = productHandle;
              if (product.du) {
                const urlHandle = product.du.split('/products/').pop()?.split('?')[0];
                if (urlHandle) {
                  productUrl = urlHandle;
                  // If the urlHandle is a variant handle / specific sku code (e.g. ccl-ps63s-e-sbu),
                  // check if there is a main product handle we should redirect to instead.
                  if (getProductData.mainProductHandle) {
                    // Check if window.allCloudflareProducts has this variant/sku code pointing to the long backplate or main product
                    // e.g. if the mainProductHandle is 'concrete-club-on-long-backplate' or 'concrete-club'
                    productUrl = getProductData.mainProductHandle;
                  } else if (window.allCloudflareProducts) {
                    const matchedProd = window.allCloudflareProducts.find(p => p.handle === urlHandle);
                    if (matchedProd && matchedProd.mainProductHandle) {
                      productUrl = matchedProd.mainProductHandle;
                    } else {
                      // Look up if urlHandle is a product code/SKU in allCloudflareProducts
                      const matchedByCode = window.allCloudflareProducts.find(p => (p.product_code || "").toLowerCase().trim() === urlHandle.toLowerCase());
                      if (matchedByCode && matchedByCode.handle) {
                        productUrl = matchedByCode.handle;
                      }
                    }
                  }
                }
              }
              //console.log("getProductData", product);
              productCount += 1;
              if (getProductData == null || getProductData.availableForSale == false) {
                isProductAvailable = false;
              }
              const productDiv = document.createElement('tr');
              productDiv.classList.add('cart-item', 'wishlist_item');
              //  Added by krunal : Start
              const productDiv2 = document.createElement('tr');
              productDiv2.classList.add('ctb_container_wrapper');
              //  Added by krunal : End
              if (isProductAvailable == false) {
                productDiv.classList.add('el-products');
              }
              let productImage = null;
              let productMediaImage = null;

              // Check if getProductData has productMedia
              if (getProductData && getProductData.productMedia) {
                const mediaArray = String(getProductData.productMedia).split(",").map(s => s.trim()).filter(Boolean);
                for (const mediaUrl of mediaArray) {
                  if (await isImageRenderable(mediaUrl)) {
                    productMediaImage = mediaUrl;
                    break;
                  }
                }
              }

              // If not found, check if there is a main product and fetch it
              if (!productMediaImage && getProductData && getProductData.mainProductHandle) {
                const mainProductData = await fetchProductByHandle(getProductData.mainProductHandle);
                if (mainProductData && mainProductData.productMedia) {
                  const mediaArray = String(mainProductData.productMedia).split(",").map(s => s.trim()).filter(Boolean);
                  for (const mediaUrl of mediaArray) {
                    if (await isImageRenderable(mediaUrl)) {
                      productMediaImage = mediaUrl;
                      break;
                    }
                  }
                }
              }

              // Fallback to placeholder if custom.product_media is empty or unavailable
              const fallbackPlaceholder = getGlobalPlaceholderImage();
              if (productMediaImage) {
                productImage = productMediaImage;
              } else {
                productImage = fallbackPlaceholder;
              }

              // Primary: read from Swym's native cprops field (crawler-safe user data)
              let fc_code = product.cprops?.fc || "";
              let fn_name = product.cprops?.fn || "";

              // Fallback 1: hash fragment (previous attempt)
              if (!fc_code && product.du && product.du.includes("#")) {
                const hashParams = new URLSearchParams(product.du.split("#")[1]);
                fc_code = hashParams.get("fc") || "";
                fn_name = decodeURIComponent(hashParams.get("fn") || "");
              }

              // Fallback 2: query params (oldest format)
              if (!fc_code && product.du && product.du.includes("fc=")) {
                fc_code = product.du.split("fc=")[1].split("&")[0].split("#")[0];
              }
              if (!fn_name && product.du && product.du.includes("fn=")) {
                fn_name = decodeURIComponent(product.du.split("fn=")[1].split("&")[0].split("#")[0]);
              }

              // Guard against literal "null" / "undefined" strings
              if (fc_code === "null" || fc_code === "undefined") fc_code = "";
              if (fn_name === "null" || fn_name === "undefined" || fn_name === "Default Title") fn_name = "";

              // Clean fc_code (remove leading dash) to match CDN image naming convention
              const clean_fc_code = fc_code ? fc_code.replace(/^-/, "") : "";

              const isAddonProduct = product.cprops?.is_addon || false;

              let productImageHTML = '';
              let imgTag = '';
              if (productImage) {
                const cleanAltText = (product.dt || "").replace(/"/g, '&quot;');
                const cleanPlaceholder = fallbackPlaceholder.replace(/'/g, "\\'");
                imgTag = `<img src="${productImage}" alt="${cleanAltText}" onerror="this.onerror=null; this.src='${cleanPlaceholder}';">`;
              }
              let matchedSwatch = null;
              if (getProductData?.category_swatches) {
                if (product.epi) {
                  const cleanEpi = product.epi.toString().trim();
                  matchedSwatch = getProductData.category_swatches.find(s => s.variant_id && s.variant_id.toString().includes(cleanEpi));
                }
                if (!matchedSwatch && fc_code) {
                  const cleanFc = fc_code.toLowerCase().trim();
                  matchedSwatch = getProductData.category_swatches.find(s => {
                    const sCode = (s.code || "").toLowerCase().trim();
                    const sSkuParts = (s.sku || "").toLowerCase().split('.');
                    return sCode === cleanFc || sSkuParts.includes(cleanFc);
                  });
                }
              }
              const shortDescription = getProductData?.shortDescription || getProductData?.custom?.short_description || getProductData?.short_description || getProductData?.backplate_name || product.custom?.short_description || product.short_description || product.backplate_name || "";
              const productSKU = variantData?.sku || matchedSwatch?.sku || getProductData?.variantSKU || product.sku;
              const displayCode = shortDescription || productSKU;
              if (displayCode) {
                skuHTML = `<div class="para product_code"><p>${displayCode}</p></div>`;
              } else {
                skuHTML = ``;
              }
              // Link to the main product page, dynamically derived above.
              // For plate-type SKUs (PS/PR segments, e.g. CCL-PS63S-E-SN), the redirect
              // must point to the "-on-long-backplate" product handle, not the base handle.
              // Detect by checking whether any SKU segment matches PS or PR plate codes.
              let _resolvedHandle = productUrl;
              if (productSKU) {
                const skuSegments = productSKU.split('-');
                const isPlateTypeSku = skuSegments.some(seg => /^(PS|PR)/i.test(seg));
                if (isPlateTypeSku && window.allCloudflareProducts) {
                  // Derive the base product code from the SKU (first segment, e.g. "CCL" from "CCL-PS63S-E-SN")
                  const baseCode = skuSegments[0].toLowerCase();
                  // Find the matching "-on-long-backplate" handle in allCloudflareProducts
                  const longBackplateProduct = window.allCloudflareProducts.find(p => {
                    const pCode = (p.product_code || '').toLowerCase().trim();
                    return pCode === baseCode && p.handle && p.handle.includes('-on-long-backplate');
                  });
                  if (longBackplateProduct && longBackplateProduct.handle) {
                    _resolvedHandle = longBackplateProduct.handle;
                  }
                }
              }

              // Build image HTML here so productSKU and _resolvedHandle are both available
              if (imgTag) {
                productImageHTML = isAddonProduct
                  ? imgTag
                  : `<a class="cart-item__link check-${product.du.split('?')[0]}" href="${window.Shopify?.routes?.root}products/${_resolvedHandle}${productSKU && productSKU !== 'undefined' && productSKU !== 'null' ? `?sku=${productSKU}` : ''}" data-product-handle="${productHandle}">${imgTag}</a>`;
              } else {
                productImageHTML = `<p>No image available</p>`;
              }


              let productQty = 1;
              if (product.qty) {
                productQty = product.qty;
              }




              let displayFinish = fn_name;
              if (!displayFinish && productSKU && typeof productSKU === 'string') {
                const skuParts = productSKU.split('-');
                const skuFinish = skuParts[skuParts.length - 1].trim();
                if (skuFinish && skuFinish.length <= 6 && skuFinish !== 'undefined' && skuFinish !== 'null') {
                  displayFinish = skuFinish;
                }
              }

              if (displayFinish) {
                if (displayFinish.includes(" - ")) {
                  displayFinish = displayFinish.split(" - ").pop().trim();
                }
                displayFinish = displayFinish.replace(/^-/, "").trim().toUpperCase();
              }
              console.log("productproductproduct", product);
              productDiv.innerHTML = `
                <td class="cart-item__media">
                  <div class="cart-item__image-container gradient global-media-settings">
                    ${productImageHTML}
                  </div>
                </td>
                <td class="cart-item__details">
                  <div>
                    ${isAddonProduct ? `<span class="cart-item__name h4 break">${product.dt}</span>` : `<a href="${window.Shopify?.routes?.root}products/${_resolvedHandle}${productSKU && productSKU !== 'undefined' && productSKU !== 'null' ? `?sku=${productSKU}` : ''}" class="cart-item__name h4 break">${product.productData.productTitle}</a>`}
                    ${displayFinish ? `<p class="cart-item__variant mb-0" style="font-size: 1.2rem; color: #555;">Finish: ${displayFinish}</p>` : ''}
                    
                    ${skuHTML}
                    
                  </div>

                </td>
                <td class="cart-item__quantity">
                  <quantity-popover>
                      <div class="wishlist-item__quantity-wrapper quantity-popover-wrapper">
                      <label class="visually-hidden" for="Quantity-1">
                          Quantity
                      </label>
                      <div class="quantity-popover-container"><wishlist-quantity-input class="quantity wishlist-quantity">
                          <button class="quantity__button" name="wishlist-minus" type="button">
                              <span class="visually-hidden">Decrease quantity for </span>
                              <svg xmlns="http://www.w3.org/2000/svg" width="5" height="2" viewBox="0 0 5 2" fill="none">
        <path d="M0.84 1.556V0.744H4.34V1.556H0.84Z" fill="black"></path>
        </svg>
                          </button>
                          <input class="quantity__input" data-quantity-variant-id="" type="number" name="updates" value="${productQty}" data-cart-quantity="${productQty}" min="0" data-min="" step="" aria-label="Quantity for " id="Quantity-1" data-index="1">
                          <button class="quantity__button" name="wishlist-plus" type="button">
                              <span class="visually-hidden">Increase quantity for </span>
                              <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
        <path d="M3.836 0.958H4.578V4.108H7.728V4.85H4.578V8H3.836V4.85H0.686V4.108H3.836V0.958Z" fill="black"></path>
        </svg>
                          </button>
                          </wishlist-quantity-input>
                      </div>

                      </div><div class="cart-item__error" id="Line-item-error-1" role="alert">
                      <small class="cart-item__error-text"></small>
                      <svg aria-hidden="true" focusable="false" class="icon icon-error" viewBox="0 0 13 13">
                          <circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"></circle>
                          <circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"></circle>
                          <path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"></path>
                          <path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7">
                      </path></svg>
                      </div>
                  </quantity-popover>
              </td>
               </div>
              `;
              // to comment PRICE, as US launch 
              //   <td class="cart-item_unit_price">
              //     <div class="product-option">
              //       <span class="d-md-none d-inline-block cart_sm_title">Unit Price :</span>
              //       ${currencySymbol}${product.productData.priceRange.minVariantPrice.amount}
              //     </div>
              //   </td>
              //   <td class="cart-item__totals  medium-hide large-up-hide">
              //       <div class="cart-item__price-wrapper">
              //         <dl class="cart-item__discounted-prices">
              //          <span class="d-md-none d-inline-block cart_sm_title">Subtotal :</span>
              //           <span class="price">
              //               ${currencySymbol}${product.productData.priceRange.minVariantPrice.amount}
              //           </span>
              //         </dl>
              //       </div>
              //   </td>
              //   <td class="cart-item__totals  small-hide">
              //     <div class="cart-item__price-wrapper">
              //       <span class="price">
              //         ${currencySymbol}${product.productData.priceRange.minVariantPrice.amount}
              //       </span>
              //     </div>
              //   </td>
              // </div>
              // `;
              productDiv2.innerHTML = `
                    <td class="cart_item_bottom item_main_bottom position-relative" colspan="6">
                     <div class="d-flex align-items-center justify-content-between flex-xl-nowrap flex-wrap item_main_bottom_container">
                  <div class="product_spec_sheet d-inline-flex">
                    <a href="#" class="d-inline-flex align-items-center download-product-spec-sheet" data-bs-id="${product.empi}">
                      <img src="https://cdn.shopify.com/s/files/1/0881/1662/5712/files/psf-ic.png?v=1731319547" alt="PDF Sheet">
                      Download Spec Sheet
                    </a>
                    <span class="loader">
                        <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" width="18px" height="18px" xmlns="http://www.w3.org/2000/svg">
                          <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                        </svg>
                    </span>
                  </div>
                  <div class="cart_share_wrapper d-flex align-items-center cart_share">
                    <div class="cart_share d-flex align-items-center">
                      <div data-wlh-id="${product.epi}" data-wlh-link="${window.Shopify?.routes?.root}products/${productUrl}" data-wlh-variantid="" data-wlh-price="0.0" data-wlh-name="${product.dt}" data-wlh-image="${productImage}" class="wishlist-hero-custom-button wishlisthero-floating" data-wlh-mode="icon_only" data-wlh-view="Collection" style="left: auto;"></div>
                      <a href="#" class="d-flex align-items-center wishlist-btn-share kb" type="button" data-product-url="${window.Shopify?.routes?.root}products/${_resolvedHandle}${productSKU && productSKU !== 'undefined' && productSKU !== 'null' ? `?sku=${productSKU}` : ''}" data-product-title="${product.dt}" data-product-id="${product.epi}" data-product-available="${isProductAvailable}" data-product-image="${productImage}">
                        <img src="https://cdn.shopify.com/s/files/1/0881/1662/5712/files/send_1.svg?v=1748848591" alt="Share">
                      </a>
                    </div>
                    <cart-remove-button class="d-inline-flex">
                      <a href="#" id="swymcs-remove-productBtn" class="button button--tertiary">
                        <img class="icon-remove " src="https://cdn.shopify.com/s/files/1/0881/1662/5712/files/delete_bin.png?v=1735982593" alt="Delete" width="auto" height="auto">
                      </a>
                    </cart-remove-button>
                  </div>
                   </div>
                </td>
                `;
              productContainer.appendChild(productDiv);
              productContainer.appendChild(productDiv2);

              const quantityInput = productDiv.querySelector('input.quantity__input[name="updates"]');
              const minusButton = productDiv.querySelector('button[name="wishlist-minus"]');
              const plusButton = productDiv.querySelector('button[name="wishlist-plus"]');
              const unitPrice = parseFloat(product.productData.priceRange.minVariantPrice.amount);
              const subtotalElements = productDiv.querySelectorAll('.cart-item__totals .price');

              function updateSubtotal() {
                const quantity = parseInt(quantityInput.value);
                const subtotal = (unitPrice * quantity).toFixed(2);
                subtotalElements.forEach(el => {
                  el.textContent = `${currencySymbol}${subtotal} `;
                });
              }

              function updateTotalPrice() {
                let total = 0;
                document.querySelectorAll('.wishlist_item').forEach(item => {
                  const isAvailable = !item.classList.contains('el-products');
                  // if(isAvailable){
                  const input = item.querySelector('.quantity__input');
                  const priceText = item.querySelector('.cart-item_unit_price .product-option')?.textContent || '';
                  const price = parseFloat(priceText.replace(currencySymbol, '').replace(/[^\d.]/g, ''));
                  const quantity = parseInt(input?.value) || 0;
                  if (!isNaN(price) && !isNaN(quantity)) {
                    total += price * quantity;
                  }
                  // }
                });

                if (country_code == 'AU') {
                  const finalTotal = total;
                  let gstPer = 0.10;
                  // if(country_code == 'AU' ){
                  //   gstPer = 0.10;
                  // }
                  const gst = finalTotal * gstPer;
                  const subtotal = finalTotal - gst;

                  document.querySelector('.subtotal-price-value').textContent = subtotal.toFixed(2);
                  document.querySelector('.gst-price-value').textContent = gst.toFixed(2);
                  document.getElementById('final-total-price').textContent = finalTotal.toFixed(2);
                } else {
                  document.querySelectorAll('.total-price').forEach(el => {
                    el.textContent = total.toFixed(2);
                  });
                }
              }

              minusButton.addEventListener('click', () => {
                let currentVal = parseInt(quantityInput.value);
                if (currentVal > 1) {
                  quantityInput.value = currentVal - 1;
                  let newQty = parseInt(quantityInput.value);
                  updateProductQty(newQty);
                  updateSubtotal();
                  updateTotalPrice();
                }
              });
              plusButton.addEventListener('click', () => {
                let currentVal = parseInt(quantityInput.value);
                quantityInput.value = currentVal + 1;
                let newQty = parseInt(quantityInput.value);
                updateProductQty(newQty);
                updateSubtotal();
                updateTotalPrice();
              });
              quantityInput.addEventListener('change', () => {
                let val = parseInt(quantityInput.value);
                if (isNaN(val) || val < 1) {
                  quantityInput.value = 1;
                }
                let newQty = parseInt(quantityInput.value);
                updateProductQty(newQty);
              });

              function updateProductQty(newQty) {
                const updatedProduct = {
                  epi: product.epi,
                  empi: product.empi,
                  du: product.du,
                  qty: newQty,
                };

                _swat.updateListItem(listId, updatedProduct, function (updatedItem) {
                  console.log("Successfully updated wishlist quantity", updatedItem);
                  updateSubtotal();
                  updateTotalPrice();
                }, function (err) {
                  console.error("Failed to update wishlist quantity", err);
                });
              }
              updateSubtotal();
              updateTotalPrice();

              productDiv2.querySelector('.download-product-spec-sheet')?.addEventListener('click', function (event) {
                event.preventDefault();
                // if(isProductAvailable){
                const dataBsId = this.getAttribute('data-bs-id');
                const loader = this.parentElement.querySelector(".loader");
                onDownloadSpecSheet(product, dataBsId, loader);
                // }
              });
              if (isProductAvailable) {
                const cartItem = {
                  id: product.epi,
                  quantity: parseInt(quantityInput.value)
                };
                // Preserve the dropdown-selected product as a line item property
                const dropdownProductName = product.cprops?.dropdown_product || "";
                if (dropdownProductName && dropdownProductName !== "null" && dropdownProductName !== "undefined") {
                  cartItem.properties = { "Dropdown Product": dropdownProductName };
                }
                productsToAddToCart.items.push(cartItem);
              }

              productDiv2.querySelector('.wishlist-btn-share')?.addEventListener('click', function (event) {
                event.preventDefault();
                const productAvailable = this.getAttribute("data-product-available");
                // if (productAvailable === "true") { // ensure comparison is with string
                let productId = this.getAttribute("data-product-id");
                let getProductUrl = this.getAttribute("data-product-url");
                let productTitle = this.getAttribute("data-product-title");
                let productImage = this.getAttribute("data-product-image");

                let productUrl = `${window.location.origin}${getProductUrl} `;

                document.getElementById("share-facebook").href = `https://www.facebook.com/sharer/sharer.php?u=${productUrl}`;
                document.getElementById("share-twitter").href = `https://twitter.com/intent/tweet?text=${productTitle}&url=${productUrl}`;
                document.getElementById("share-linkedin").href = `https://www.linkedin.com/shareArticle?mini=true&url=${productUrl}&title=${productTitle}`;
                document.getElementById("share-pinterest").href = `https://www.pinterest.com/pin/create/button/?url=${productUrl}&media=${productImage}&description=${productTitle}`;

                document.getElementById("productLink").value = productUrl;

                let modal = new bootstrap.Modal(document.getElementById("acfProductModal"));
                modal.show();
                // }
              });


              productDiv2.querySelector('#swymcs-remove-productBtn')?.addEventListener('click', () => {
                event.preventDefault();
                // if(isProductAvailable){
                let selectedProduct = {
                  epi: product.epi,
                  empi: product.empi,
                  du: product.du
                }
                _swat.deleteFromList(listId, selectedProduct, function (deletedProduct) {
                  console.log("Successfully deleted the Product", deletedProduct);
                  const mainWishlistWrapper = document.querySelector(".custom_wishlist_block");
                  mainWishlistWrapper.scrollIntoView({ behavior: 'smooth', block: 'start' });
                  document.getElementById('swym-wishlist-loader').classList.remove('swymcs-hide-container');
                  document.querySelector('.main_cart_items_wrapper').classList.add('d-none');
                  document.querySelector('.main_wishlist_footer_wrapper').classList.add('d-none');
                  document.querySelector('.cart-items').classList.add('d-none');
                  _swat.fetchListDetails(listConfig, onSuccess, onError);
                }, function (error) {
                  console.error('Failed to remove from wishlist', error);
                });
                // }
              });
            } else {
              const errorDiv = document.createElement('div');
              errorDiv.classList.add('cart-item__error');
              errorDiv.innerHTML = `<small class="cart-item__error-text check-${window.Shopify?.country}">Product <strong>${product.dt}</strong> is not available.</small>
                                            <svg aria-hidden="true" focusable="false" class="icon icon-error" viewBox="0 0 13 13">
                                            <circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"></circle>
                                            <circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"></circle>
                                            <path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"></path>
                                            <path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7">
                                          </path></svg>`;
              errorWrapper.appendChild(errorDiv);
            }
          } catch (error) {
            console.error('Error fetching product data:', error);
          }
        }

        document.getElementById('swym-wishlist-loader').classList.add('swymcs-hide-container');
        document.querySelector('.main_cart_items_wrapper').classList.remove('d-none');
        if (productCount > 0) {
          document.querySelector('.main_wishlist_footer_wrapper').classList.remove('d-none');
          document.querySelector('.cart-items').classList.remove('d-none');
        }
        const productRows = document.querySelectorAll("tr.el-products");

      } else {
        const mainWrapper = document.getElementById('main-cart-items');
        const noProductDiv = document.createElement('div');
        noProductDiv.classList.add('empty-cart-item-wrapper');
        noProductDiv.innerHTML = '<p>No products found in the wishlist.</p>';
        mainWrapper.appendChild(noProductDiv);
        document.getElementById('swym-wishlist-loader').classList.add('swymcs-hide-container');
        document.querySelector('.main_cart_items_wrapper').classList.remove('d-none');
      }
      console.log(productCount);
    };

    let onError = function (error) {
      console.log("Error while fetching List details", error);
      document.getElementById('swym-wishlist-loader').classList.add('swymcs-hide-container');
      document.querySelector('.main_cart_items_wrapper').classList.remove('d-none');
      const productContainer = document.querySelector('.wishlist-products');
      if (productContainer) {
        productContainer.innerHTML = '<tr><td colspan="6">This spec book link is invalid or has expired.</td></tr>';
      }
    };
    const addToCartBtn = document.querySelector('.add-to-cart-btn');
    if (addToCartBtn) {
      addToCartBtn.addEventListener('click', function (e) {
        e.preventDefault();

        if (!lastListDetails || !lastListDetails.items || lastListDetails.items.length === 0) {
          alert('Your wishlist is empty or product is not available.');
          return;
        }

        const itemsToCart = [];

        lastListDetails.items.forEach(product => {
          if (!product.productData || product.productData.availableForSale === false) {
            return;
          }

          // Read current quantity from input in DOM if available
          let qty = parseInt(product.qty) || 1;
          const productRow = document.querySelector(`.wishlist-btn-share[data-product-id="${product.epi}"]`)?.closest('tr');
          if (productRow) {
            const qtyInput = productRow.querySelector('input.quantity__input[name="updates"]');
            if (qtyInput && !isNaN(parseInt(qtyInput.value))) {
              qty = parseInt(qtyInput.value);
            }
          }

          // Extract finish name from cprops or fallback query/hash params
          let fnName = product.cprops?.fn || "";
          if (!fnName && product.du && product.du.includes("fn=")) {
            fnName = decodeURIComponent(product.du.split("fn=")[1].split("&")[0].split("#")[0]);
          }
          if (!fnName && product.du && product.du.includes("#")) {
            const hashParams = new URLSearchParams(product.du.split("#")[1]);
            fnName = decodeURIComponent(hashParams.get("fn") || "");
          }
          if (fnName === "null" || fnName === "undefined" || fnName === "Default Title") fnName = "";

          // 1. Add Main Product
          const mainItem = {
            id: product.epi,
            quantity: qty
          };

          const properties = {};
          const dropdownProductName = product.cprops?.dropdown_product || "";
          if (dropdownProductName && dropdownProductName !== "null" && dropdownProductName !== "undefined") {
            properties["Dropdown Product"] = dropdownProductName;
          }
          if (fnName) {
            properties["Finish"] = fnName;
          }
          if (Object.keys(properties).length > 0) {
            mainItem.properties = properties;
          }
          itemsToCart.push(mainItem);
        });

        if (itemsToCart.length === 0) {
          alert('Your wishlist is empty or product is not available.');
          return;
        }

        function addProductsToCart(cartData) {
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(cartData),
          })
            .then(async (response) => {
              if (response.ok) {
                const data = await response.json();
                console.log('Cart updated:', data);
                window.location.href = `${window.Shopify?.routes?.root}cart`; // Redirect on success
              } else {
                const errorData = await response.json(); // or .text() if not JSON
                throw new Error(errorData.description || errorData.message || 'Unknown error occurred');
              }
            })
            .catch((error) => {
              console.error('Error adding to cart:', error);
              alert(`Error: ${error.message}`);
            });
        }
        addProductsToCart({ items: itemsToCart });
      });
    }
    const shareSpecBook = document.getElementById('share-spec-book');
    shareSpecBook.addEventListener("click", function (event) {
      event.preventDefault();
      let onShareLinkSuccess = (link, listId) => {
        console.log("Successfully Generated Link ", link, listId);
        generatedShareLink = link;
        document.getElementById("specbookLink").value = generatedShareLink;
        // Show Bootstrap modal
        emailModal.show();
      }
      let onShareLinkError = (error) => {
        // Error is an xhrObject
        console.log("Error while generating the link", error)
      }

      _swat.generateSharedListURL(listId, onShareLinkSuccess, onShareLinkError);
    });



    const contactBtn = document.querySelector('.contact-us-btn-specbook');
    if (contactBtn) {
      contactBtn.addEventListener('click', function (e) {
        e.preventDefault();
        let specbookLink = document.getElementById('specbookLink');
        let specUrl = (specbookLink && specbookLink.value) ? specbookLink.value : '';

        if (specUrl) {
          window.location.href = '/pages/contact-us?specbook_url=' + encodeURIComponent(specUrl);
        } else {
          let onContactLinkSuccess = (link) => {
            try {
              const urlObj = new URL(link);
              link = window.location.origin + urlObj.pathname + urlObj.search;
            } catch (e) {
              console.error("Error parsing link", e);
            }
            //console.log('/pages/contact-us?specbook_url=' + encodeURIComponent(link));
            window.location.href = '/pages/contact-us?specbook_url=' + encodeURIComponent(link);
          };
          let onContactLinkError = (error) => {
            window.location.href = '/pages/contact-us';
          };
          _swat.generateSharedListURL(listId, onContactLinkSuccess, onContactLinkError);
        }
      });
    }
    _swat.fetchListDetails(listConfig, onSuccess, onError);
  }
  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }
  const __urlParamsForGate = new URLSearchParams(window.location.search);
  const __isShareLink = __urlParamsForGate.has('hkey') || __urlParamsForGate.has('lid');
  if (document.body.classList.contains('template-page-swym-product') || __isShareLink) {
    window.SwymCallbacks.push(onSwymLoadCallbackProducts);
  }
})();

async function isImageAccessible(url) {
  if (!url || typeof url !== "string" || !url.trim()) {
    return false;
  }
  let cleanUrl = url.split(",")[0].trim();
  if (cleanUrl.startsWith("//")) {
    cleanUrl = "https:" + cleanUrl;
  }
  if (!cleanUrl) return false;

  return new Promise((resolve) => {
    const img = new Image();
    let settled = false;
    const finish = (result) => {
      if (settled) return;
      settled = true;
      clearTimeout(timeoutId);
      resolve(result);
    };

    img.onload = () => {
      finish(img.naturalWidth > 0 && img.naturalHeight > 0 ? cleanUrl : false);
    };

    img.onerror = () => {
      finish(false);
    };

    const timeoutId = setTimeout(() => {
      finish(false);
    }, 5000);

    img.src = cleanUrl;
  });
}

async function resolveAccessibleProductImage(candidates) {
  const defaultPlaceholder = getGlobalPlaceholderImage();

  for (const url of candidates) {
    const validUrl = await isImageAccessible(url);
    if (validUrl) {
      return validUrl;
    }
  }

  return defaultPlaceholder;
}

async function resolveAccessibleProductLineImage(candidates) {
  for (const url of candidates) {
    const validUrl = await isImageAccessible(url);
    if (validUrl) {
      return validUrl;
    }
  }

  return null;
}

async function getAllSpecData(productDatas) {
  // console.log(productDatas.items);
  // return;
  const finalTotalPrice = document.getElementById('final-total-price').textContent;
  const loader = document.querySelector(".download-all-cart-loader");
  loader.style.display = "inline-block";
  let itemDetails = [];
  for (let productItem of productDatas.items) {
    console.log(productItem.iu);
    console.log(productItem.productData?.productImage);

    let candidateUrls = [];
    let primaryUrl = productItem.iu || productItem.productData?.productImage;
    if (primaryUrl) candidateUrls.push(primaryUrl);

    let variantData = null;
    let real_epi = productItem.epi;
    let fc_code = "";
    let fn_name = "";

    const epiStr = productItem.epi ? String(productItem.epi) : "";
    if (epiStr && epiStr.includes("_")) {
      const parts = epiStr.split("_");
      real_epi = parts[0] || "";
      fc_code = parts[1] || "";
      fn_name = decodeURIComponent(parts[2] || "");
    }

    if (real_epi) {
      variantData = await fetchVariantById(real_epi);
    }

    // Fallback Extractions
    if (!fc_code && variantData) fc_code = variantData.sku;
    if (!fc_code && productItem.du && productItem.du.includes("fc=")) {
      fc_code = productItem.du.split("fc=")[1].split("&")[0];
    }

    if (productItem.productData && productItem.productData.productHandle) {
      const parentHandle = productItem.productData.mainProductHandle || productItem.productData.productHandle;
      const sku = productItem.productData.variantSKU;

      if (parentHandle && sku) {
        candidateUrls.push(`https://d2144d4bgy6719.cloudfront.net/door-handles/${parentHandle}/images/${sku}.jpg`);
      } else if (fc_code) {
        const clean_fc_code = fc_code.replace(/^-/, "");
        candidateUrls.push(`https://d2144d4bgy6719.cloudfront.net/door-handles/${productItem.productData.productHandle}/images/${clean_fc_code}.jpg`);
      }
    }

    if (!fn_name && variantData) {
      const finishOption = variantData.selectedOptions?.find(o => o.name.toLowerCase() === "finish");
      fn_name = finishOption ? finishOption.value : variantData.title;
    } else if (!fn_name && productItem.du && productItem.du.includes("fn=")) {
      fn_name = decodeURIComponent(productItem.du.split("fn=")[1].split("&")[0]);
    }

    if (fn_name === "Default Title") fn_name = "";

    let finalTitle = productItem.dt;
    if (fn_name && finalTitle && !finalTitle.includes(fn_name)) {
      finalTitle = `${finalTitle} - ${fn_name}`;
    }

    const mainProductHandle = productItem.productData?.mainProductHandle;
    if (mainProductHandle != null) {
      const mainProductData = await fetchProductByHandle(mainProductHandle);
      if (mainProductData?.productImage) {
        candidateUrls.push(mainProductData.productImage);
      }
    }

    const validatedImage = await resolveAccessibleProductImage(candidateUrls);
    const validatedProductLineImage = await resolveAccessibleProductLineImage([productItem.productData?.productDimensionFile || ""]);

    if (productItem.productData) {
      console.log("productItem ", productItem);
      let zapierData = {
        productId: productItem.epi,
        productTitle: finalTitle,
        productHandle: productItem.productData.productHandle,
        productDescription: productItem.productData?.productDescription || "",
        productDimensionFile: validatedProductLineImage,
        productSpecification: productItem.productData?.productSpecification || null,
        variantSKU: productItem.productData?.sku || null,
        productImage: validatedImage || getGlobalPlaceholderImage(),
      };
      itemDetails.push(zapierData);
    }
  }
  const cartData = {
    items: itemDetails
  };

  fetch(`${window.pdf_url}`, {
    method: 'POST',
    body: JSON.stringify({ cartData })
  })
    .then(response => response.json())
    .then(zapierResponse => {
      console.log('Data successfully sent to Zapier:', zapierResponse);
      if (zapierResponse.status === 200 && zapierResponse.pdf_url) {
        // Fetch the PDF file as a blob
        fetch(zapierResponse.pdf_url)
          .then(res => res.blob())
          .then(blob => {
            const blobUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = blobUrl;
            link.setAttribute('download', 'Spec Book.pdf'); // You can name the file here
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(blobUrl);
          })
          .catch(err => {
            console.error('Failed to fetch and download PDF:', err);
            alert("❌ Failed to download the PDF file.");
          });
      }
    })
    .catch(error => {
      console.error('Error sending data to Zapier:', error);
      alert("❌ Failed to download spec sheets. Please try again.");
    })
    .finally(() => {
      loader.style.display = "none";
      loader.parentNode.classList.remove('loader_active');
    });
}

async function onDownloadSpecSheet(product, dataBsId, loader) {
  let candidateUrls = [];
  let primaryUrl = product.iu || product.productData?.productImage;
  if (primaryUrl) candidateUrls.push(primaryUrl);

  let variantData = null;
  let real_epi = product.epi;
  let fc_code = "";
  let fn_name = "";

  const epiStr = product.epi ? String(product.epi) : "";
  if (epiStr && epiStr.includes("_")) {
    const parts = epiStr.split("_");
    real_epi = parts[0] || "";
    fc_code = parts[1] || "";
    fn_name = decodeURIComponent(parts[2] || "");
  }

  if (real_epi) {
    variantData = await fetchVariantById(real_epi);
  }

  // Fallback Extractions
  if (!fc_code && variantData) fc_code = variantData.sku;
  if (!fc_code && product.du && product.du.includes("fc=")) {
    fc_code = product.du.split("fc=")[1].split("&")[0];
  }

  const resolvedParent = resolveActualHandle(product.productData);
  if (fc_code && resolvedParent) {
    candidateUrls.push(`https://d2144d4bgy6719.cloudfront.net/door-handles/${resolvedParent}/images/${fc_code}.jpg`);
  }

  if (!fn_name && variantData) {
    const finishOption = variantData.selectedOptions?.find(o => o.name.toLowerCase() === "finish");
    fn_name = finishOption ? finishOption.value : variantData.title;
  } else if (!fn_name && product.du && product.du.includes("fn=")) {
    fn_name = decodeURIComponent(product.du.split("fn=")[1].split("&")[0]);
  }

  if (fn_name === "Default Title") fn_name = "";

  let finalTitle = product.dt;
  if (fn_name && finalTitle && !finalTitle.includes(fn_name)) {
    finalTitle = `${finalTitle} - ${fn_name}`;
  }

  const mainProductHandle = product.productData?.mainProductHandle;
  if (mainProductHandle != null) {
    const mainProductData = await fetchProductByHandle(mainProductHandle);
    if (mainProductData?.productImage) {
      candidateUrls.push(mainProductData.productImage);
    }
  }

  console.log("product", product);
  const validatedImage = await resolveAccessibleProductImage(candidateUrls);
  const validatedProductLineImage = await resolveAccessibleProductLineImage([product.productData?.productDimensionFile || ""]);
  let zapierData = {
    productId: product.epi,
    productTitle: finalTitle,
    productHandle: product.productData.productHandle,
    productDescription: product.productData?.productDescription || "",
    productDimensionFile: validatedProductLineImage,
    productSpecification: product.productData?.productSpecification || null,
    variantSKU: product.productData?.variantSKU || null,
    productImage: validatedImage || getGlobalPlaceholderImage(),
  };
  const cartData = {
    items: [zapierData]
  };
  loader.style.display = "inline-block";
  // Debug: log payload before sending to Zapier worker (single)
  console.log('DEBUG: cartData to Zapier (single):', cartData);
  console.log('DEBUG: cartData JSON (single):', JSON.stringify({ cartData }));

  fetch(`${window.pdf_url}`, {
    method: "POST",
    body: JSON.stringify({ cartData }),
  })
    .then((response) => response.json())
    .then((zapierResponse) => {
      console.log(
        "Data successfully sent to Zapier:",
        zapierResponse
      );
      if (zapierResponse.status === 200 && zapierResponse.pdf_url) {
        // Fetch the PDF file as a blob
        fetch(zapierResponse.pdf_url)
          .then(res => res.blob())
          .then(blob => {
            const blobUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = blobUrl;
            const safeTitle = product.dt.replace(/[^a-z0-9_\-]/gi, "_").toLowerCase();
            link.setAttribute("download", `Spec Sheet.pdf`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(blobUrl);
            loader.style.display = "none";
          })
          .catch(err => {
            console.error('Failed to fetch and download PDF:', err);
            alert("❌ Failed to download the PDF file.");
          });
      }
    })
    .catch((error) => {
      console.error("Error sending data to Zapier:", error);
      alert(
        "❌ Failed to download spec sheets. Please try again."
      );
    })
    .finally(() => {
      // loader.style.display = "none";
    });
}


async function fetchProductByProductId(productId) {
  // Try to find in our global Cloudflare cache first
  const cleanId = productId.toString();
  if (window.allCloudflareProducts) {
    const cached = window.allCloudflareProducts.find(p => p.id.includes(cleanId) || p.handle === cleanId);
    if (cached) {
      return {
        productId: cached.id,
        productTitle: cached.title,
        productDescription: cached.description || "",
        shortDescription: cached.custom?.short_description || cached.short_description || cached.backplate_name || "",
        productType: cached.productType,
        productHandle: cached.handle,
        productVendor: cached.vendor,
        productDimensionFile: cached.dimensionFile || null,
        mainProductHandle: cached.mainProductHandle || null,
        rosset: cached.rosset || null,
        function: cached.function || null,
        finish: cached.finish || null,
        productSpecification: cached.productSpecification || null,
        variantId: cached.variants?.[0]?.id || null,
        variantSKU: cached.variants?.[0]?.sku || null,
        availableForSale: true,
        priceRange: cached.price,
        productImage: cached.images?.[0] || null,
        category_swatches: cached.category_swatches || null,
        productMedia: cached.product_media || null,
      };
    }
  }

  // Fallback to GraphQL only if not found in cache
  const query = `
      query ($productId: ID!) @inContext(country: ${country_code}) {
        product(id: $productId) {
          id
          title
          description
          handle
          productType
          vendor
          availableForSale
          shortDescription: metafield(namespace: "custom", key: "short_description") { value }
          mainProductHandle: metafield(namespace: "custom", key: "main_product_handle"){ value }
          technicalspecification: metafield(namespace: "custom", key: "technical_specification"){ value }
          dimensionFile: metafield(namespace: "custom", key: "line_drawing") {
            value
          }
          productMedia: metafield(namespace: "custom", key: "product_media") {
            value
          }
          images(first: 1) { edges { node { url } } }
          priceRange { minVariantPrice { amount currencyCode } }
          variants(first: 1) { edges { node { id sku } } }
        }
      }
    `;

  const variables = { productId: `gid://shopify/Product/${productId}` };
  try {
    const response = await fetch(
      `https://${storeDomain}/api/${apiVersion}/graphql.json`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": accessToken,
        },
        body: JSON.stringify({ query, variables }),
      }
    );

    const { data, errors } = await response.json();

    if (errors) {
      console.error("Error fetching product by handle:", errors);
      return null;
    }

    if (!data.product) {
      return null;
    }
    console.log("Fetched product data:", data);
    //let fileInfo = data.product.dimensionFile.value ? data.product.dimensionFile.value : null;
    let fileInfo = data.product?.dimensionFile?.value ?? '';
    // Normalize productMedia: parse CSV into array, pick first valid URL for productImage
    let mediaInfo = data.product.productMedia?.value ?? null;
    let mediaArray = [];
    if (mediaInfo) {
      mediaArray = String(mediaInfo).split(",").map(s => s.trim()).filter(Boolean);
    }
    const firstMedia = mediaArray[0] || data.product.images.edges[0]?.node?.url || null;
    return {
      productId: data.product.id,
      productTitle: data.product.title,
      productDescription: data.product?.description || "",
      shortDescription: data.product.shortDescription?.value || "",
      productType: data.product.productType,
      productHandle: data.product.handle,
      productVendor: data.product.vendor,
      productDimensionFile: fileInfo,
      mainProductHandle: data.product.mainProductHandle?.value || null,
      rosset: data.product.rosset_code?.value || null,
      function: data.product.function_code?.value || null,
      finish: data.product.finish_code?.value || null,
      productSpecification: data.product.technicalspecification?.value || null,
      variantId: data.product.variants.edges[0]?.node.id || null,
      variantSKU: data.product.variants.edges[0]?.node.sku || null,
      availableForSale: data.product.availableForSale,
      priceRange: data.product.priceRange,
      productImage: firstMedia,
      productMedia: mediaInfo,
    };
  } catch (err) {
    console.error("Fetch product error:", err);
    return null;
  }
}

function makeHndle(str) {
  return str.replace(/[^a-z0-9]+/gi, "-").toLowerCase();
}

async function fetchVariantById(variantId) {
  // Check our global Cloudflare cache first (if loaded)
  const cleanId = variantId.toString();
  if (window.allCloudflareProducts) {
    for (const p of window.allCloudflareProducts) {
      const found = p.variants?.find(v => v.id.includes(cleanId));
      if (found) return found;
      const swatchFound = p.category_swatches?.find(s => s.variant_id && s.variant_id.includes(cleanId));
      if (swatchFound) {
        return {
          id: swatchFound.variant_id,
          title: swatchFound.name,
          sku: swatchFound.sku,
          image: { url: swatchFound.image_url }
        };
      }
    }
  }

  const query = `
      query ($variantId: ID!) {
        node(id: $variantId) {
          ... on ProductVariant {
            id
            title
            sku
            image {
              url
            }
            selectedOptions {
              name
              value
            }
          }
        }
      }
    `;
  const variables = { variantId: `gid://shopify/ProductVariant/${variantId}` };
  try {
    const response = await fetch(
      `https://${storeDomain}/api/${apiVersion}/graphql.json`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": accessToken,
        },
        body: JSON.stringify({ query, variables }),
      }
    );
    const jsonResponse = await response.json();
    return jsonResponse?.data?.node || null;
  } catch (err) {
    console.error("🔥 [fetchVariantById] Fetch Error:", err);
    return null;
  }
}

async function fetchProductByHandle(mainProductHandle) {
  // Check our global Cloudflare cache first (if loaded)
  if (window.allCloudflareProducts) {
    const cached = window.allCloudflareProducts.find(p => p.handle === mainProductHandle);
    if (cached) {
      return {
        productId: cached.id,
        productTitle: cached.title,
        productDescription: cached.description || "",
        shortDescription: cached.custom?.short_description || cached.short_description || cached.backplate_name || "",
        productHandle: cached.handle,
        productImage: cached.images[0] || null,
        category_swatches: cached.category_swatches || null,
        productMedia: cached.product_media || null,
      };
    }
  }

  const query = `
    query ($handle: String!) @inContext(country: ${country_code}) {
      product(handle: $handle) {
        id
        title
        description
        handle
        shortDescription: metafield(namespace: "custom", key: "short_description") {
          value
        }
        productMedia: metafield(namespace: "custom", key: "product_media") {
          value
        }
        images(first: 1) {
          edges {
            node {
              url
              altText
            }
          }
        }
      }
    }
  `;

  const variables = { handle: mainProductHandle };
  try {
    const response = await fetch(
      `https://${storeDomain}/api/${apiVersion}/graphql.json`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": accessToken,
        },
        body: JSON.stringify({ query, variables }),
      }
    );

    const { data, errors } = await response.json();

    if (errors) {
      console.error("Error fetching product by handle:", errors);
      return null;
    }

    if (!data.product) {
      return null;
    }

    return {
      productId: data.product.id,
      productTitle: data.product.title,
      productDescription: data.product?.description || "",
      shortDescription: data.product.shortDescription?.value || "",
      productHandle: data.product.handle,
      productImage: data.product.images.edges[0]?.node.url || null,
      productMedia: data.product.productMedia?.value || null,
    };
  } catch (err) {
    console.error("Fetch product error:", err);
    return null;
  }
}

if (document.getElementById('submitEmail')) {
  document.getElementById('submitEmail').addEventListener("click", function () {
    const email = document.getElementById('emailInput').value.trim();

    if (!email || !generatedShareLink) {
      alert("Please enter a valid email and make sure the link is generated.");
      return;
    }

    const subject = encodeURIComponent("Shared Spec Book Link");
    const body = encodeURIComponent(`Hi,\n\nHere's the link to the spec book:\n${generatedShareLink}\n\nBest regards.`);
    const mailtoURL = `mailto:${email}?subject=${subject}&body=${body}`;

    // Open the default mail client
    window.location.href = mailtoURL;

    // Hide the modal
    emailModal.hide();
  });
}
function copySpecbookLink() {
  console.log(document.getElementById("specbookLink").value);
  let input = document.getElementById("specbookLink").value;
  // console.log('input', input)
  const copyBtn = document.querySelector(".share-specbook-link button");
  navigator.clipboard.writeText(input)
    .then(() => {
      copyBtn.textContent = "Link Copied";
      setTimeout(() => {
        copyBtn.textContent = "Copy Link";
      }, 5000); // reset after 2 seconds
    })
    .catch(err => {
      copyBtn.textContent = "Copy Link";
    });
  // input.select();
  // document.execCommand("copy");
  // alert("Link copied to clipboard: " + input.value);
}